import React from "react";

const OrdersIcon = (props) => {
  return (
    <svg
      {...props}
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
    <g transform="scale(0.70) translate(6,6)"> 
      <path
        fill="none"
        d="M18 4.5V13.5"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="none"
        d="M25.14 4.5C25.699 4.49617 26.2482 4.64861 26.7251 4.95112C27.202 5.25363 27.5876 5.69577 27.84 6.15005L31.185 12.8686C31.3919 13.2837 31.4997 13.7412 31.5 14.2051V28.5C31.5 29.2956 31.1839 30.0587 30.6213 30.6213C30.0587 31.1839 29.2956 31.5 28.5 31.5H7.5C6.70435 31.5 5.94129 31.1839 5.37868 30.6213C4.81607 30.0587 4.5 29.2956 4.5 28.5V14.2081C4.50003 13.7426 4.60838 13.2844 4.817 12.8656L8.175 6.15005C8.42544 5.70105 8.80822 5.26101 9.2829 4.95511C9.75757 4.64921 10.3014 4.49682 10.86 4.5H25.14Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="none"
        d="M4.58093 13.5194H31.419"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      </g>
    </svg>
  );
};

export default OrdersIcon;
